import * as React from 'react';
import { Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import NotFound from 'bundles/phoenix/components/NotFound';
import ProfessionalCertificateCategoryPages from 'bundles/professional-certificate-category-pages/components/ProfessionalCertificateCategoryPages';
import CertificatesCategoryHubPage from 'bundles/professional-certificate-category-pages/components/certificates/CertificatesCategoryHubPage';

const reactRoute = (
  <Route name="app" component={ProfessionalCertificateCategoryPages} path="/">
    <CourseraRoute
      name="certificatesCategoryHub"
      component={CertificatesCategoryHubPage}
      path="/certificates/:categorySlug"
      handle={{
        tracking: {
          data: () => ({
            page: { type: 'certs_domain_hub' },
          }),
        },
      }}
    />
    <Route component={NotFound} path="*" />
  </Route>
);

export default reactRoute;
